// Max lengths from the highlighted countries in the phone number reference sheet.
export const CountryPhoneRules = {
    "+91": { maxLength: 10, minLength: 10 },
    "+965": { maxLength: 8, minLength: 8 },
    "+60": { maxLength: 10, minLength: 7 },
    "+977": { maxLength: 10, minLength: 8 },
    "+968": { maxLength: 8, minLength: 8 },
    "+974": { maxLength: 8, minLength: 8 },
    "+966": { maxLength: 9, minLength: 8 },
    "+65": { maxLength: 8, minLength: 8 },
    "+27": { maxLength: 9, minLength: 9 },
    "+94": { maxLength: 9, minLength: 9 },
    "+971": { maxLength: 9, minLength: 8 },
};

export const DEFAULT_PHONE_MAX_LENGTH = 14;

export const getPhoneMaxLength = (countryCode) =>
    CountryPhoneRules[countryCode]?.maxLength ?? DEFAULT_PHONE_MAX_LENGTH;

export const validateMobileNumber = (countryCode, number) => {
    if (!countryCode) {
        return { valid: false, message: "Please select a ISD Code." };
    }

    if (!number) {
        return { valid: false, message: "Please enter a mobile number." };
    }

    const rules = CountryPhoneRules[countryCode];

    if (!rules) {
        if (number.length > DEFAULT_PHONE_MAX_LENGTH) {
            return {
                valid: false,
                message: `Mobile number should not exceed ${DEFAULT_PHONE_MAX_LENGTH} digits.`,
            };
        }
        return { valid: true, message: "" };
    }

    if (number.length > rules.maxLength) {
        return {
            valid: false,
            message: `Mobile number should not exceed ${rules.maxLength} digits for the selected country.`,
        };
    }

    if (number.length < rules.minLength) {
        return {
            valid: false,
            message: `Mobile number should be at least ${rules.minLength} digits for the selected country.`,
        };
    }

    return { valid: true, message: "" };
};
